import { Chip, Icon, useTheme } from "@mui/material";
import { IWebTicket } from "app/WebEvent/interfaces";
import trans from "helpers/trans";
import { useSelector } from "react-redux";
import { useBasket } from "../basketContext";
import { getPublicSubtranslation } from "helpers/getSubtranslation";

type AvailabilityProps = {
    ticket: IWebTicket;
    quantity: number;
};

const Availability: React.FC<AvailabilityProps> = ({ ticket, quantity }) => {
    const {
        "general-ticket_available_presentation": ticketAvailablePresentantion,
    } = useSelector((state: any) => state.web.settings.location_settings);

    const theme = useTheme();

    const { event, groupUsage } = useBasket();

    const groupQuantity = groupUsage[ticket.event_ticket_group_id] || 0;

    const chipData = {
        backgroundColor: "#D9F0E4",
        color: "#054808",
        iconColor: "#007D39!important",
        text: trans("event.webEvent.modal.ticketModal.available", {
            available: ticket.current_available - groupQuantity,
        }),
    };

    if (!event) {
        return null;
    }

    // global settings
    if (event.event_availability_presentations.length === 0) {
        if (ticketAvailablePresentantion === -1) {
            return null;
        }

        if (
            ticketAvailablePresentantion > 0 &&
            ticket.current_available >= ticketAvailablePresentantion
        ) {
            return null;
        }

        if (ticket.current_available === 0) {
            chipData.text = trans("event.webEvent.modal.ticketModal.soldOut");
        }

        if (
            groupQuantity > ticket.current_available ||
            ticket.current_available === 0
        ) {
            chipData.backgroundColor = "#FFC3BB66";
            chipData.color = "#650000";
            chipData.iconColor = "#970000!important";
        }
    } else {
        if (
            event.event_availability_presentations.length > 1 ||
            event.event_availability_presentations[0].value > 0
        ) {
            let found = false;
            for (const value of (
                event.event_availability_presentations ?? []
            ).sort((a: any, b: any) => a.value - b.value)) {
                if (value.value > ticket.current_available) {
                    chipData.backgroundColor = value.color;
                    chipData.color = theme.palette.getContrastText(value.color);
                    chipData.iconColor = chipData.color + "!important";
                    chipData.text =
                        getPublicSubtranslation(value.subtranslations.text, {
                            available: ticket.current_available - groupQuantity,
                        }) ?? chipData.text;
                    found = true;
                    break;
                }
            }

            if (!found) {
                return null;
            }
        } else if (event.event_availability_presentations[0].value === 0) {
            chipData.backgroundColor =
                event.event_availability_presentations[0].color;
            chipData.color = theme.palette.getContrastText(
                event.event_availability_presentations[0].color,
            );
            chipData.iconColor = chipData.color + "!important";
            chipData.text =
                getPublicSubtranslation(
                    event.event_availability_presentations[0].subtranslations
                        .text,
                    { available: ticket.current_available - groupQuantity },
                ) ?? chipData.text;
        } else {
            return null;
        }
    }

    return (
        <Chip
            sx={{
                height: 28,
                minWidth: "fit-content",
                fontFamily: "'Noto Sans'",
                fontWeight: 500,
                fontSize: 12,
                backgroundColor: chipData.backgroundColor,
                color: chipData.color,
            }}
            icon={
                <Icon
                    sx={{
                        ml: "8px !important",
                        fontSize: 20,
                        color: chipData.iconColor,
                    }}
                >
                    {groupQuantity >= ticket.current_available ||
                    ticket.current_available === 0
                        ? "highlight_off"
                        : "check_circle_outline"}
                </Icon>
            }
            label={chipData.text}
        />
    );
};

export default Availability;
